import AsyncStorage from '@react-native-async-storage/async-storage'
import { each } from 'lodash'
import { useCallback, useEffect, useState, type FC, type ReactNode } from 'react'

import { SplashScreen } from '@/components'
import { AppStateContext } from '@/contexts'

const KEY_PREFIX = '@dateability'
const EXPO_PUSH_TOKEN_KEY = `${KEY_PREFIX}/expo-push-token`
const HIDE_MATCH_SHEET_KEY = `${KEY_PREFIX}/hide-match-sheet`

export interface AppStateProviderProps {
  children: ReactNode
}

export const AppStateProvider: FC<AppStateProviderProps> = ({ children }) => {
  const [expoPushToken, _setExpoPushToken] = useState<string | null>(null)
  const [hideMatchSheet, _setHideMatchSheet] = useState(false)
  const [loaded, setLoaded] = useState(false)

  const setExpoPushToken = useCallback(async (token: string | null) => {
    if (token) {
      await AsyncStorage.setItem(EXPO_PUSH_TOKEN_KEY, token)
    } else {
      await AsyncStorage.removeItem(EXPO_PUSH_TOKEN_KEY)
    }

    _setExpoPushToken(token)
  }, [])
  const setHideMatchSheet = useCallback(async (hide: boolean) => {
    if (hide) {
      await AsyncStorage.setItem(HIDE_MATCH_SHEET_KEY, '1')
    } else {
      await AsyncStorage.removeItem(HIDE_MATCH_SHEET_KEY)
    }

    _setHideMatchSheet(hide)
  }, [])
  const reload = useCallback(async () => {
    const values = await AsyncStorage.multiGet([EXPO_PUSH_TOKEN_KEY, HIDE_MATCH_SHEET_KEY])

    each(values, ([key, value]) => {
      switch (key) {
        case EXPO_PUSH_TOKEN_KEY:
          _setExpoPushToken(value)
          break
        case HIDE_MATCH_SHEET_KEY:
          _setHideMatchSheet(!!value)
          break
      }
    })
  }, [])

  useEffect(() => {
    reload().then(() => setLoaded(true))
  }, [reload])

  if (!loaded) {
    return <SplashScreen />
  }

  return (
    <AppStateContext.Provider
      value={{
        expoPushToken,
        hideMatchSheet,
        reload,
        setExpoPushToken,
        setHideMatchSheet
      }}
    >
      {children}
    </AppStateContext.Provider>
  )
}
